import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { NAV_LINKS } from "../data/content";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B1329] text-slate-300">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <Logo light />
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
            Precision engineering and manufacturing company established in 1995,
            based in Hyderabad, Telangana, India. Tooling, Dies, machined components
            and custom industrial parts built to customer drawings.
          </p>
        </div>
        <div>
          <h3 className="text-sm font-semibold tracking-widest uppercase text-white">Quick Links</h3>
          <ul className="mt-4 space-y-2.5">
            {NAV_LINKS.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  data-testid={`footer-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-slate-400 hover:text-white transition-colors duration-150"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold tracking-widest uppercase text-white">Contact</h3>
          <ul className="mt-4 space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-3">
              <Phone size={15} className="text-[#2563EB]" />
              <a href="tel:+919440080160" data-testid="footer-phone" className="hover:text-white transition-colors">
                +91 94400 80160
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={15} className="text-[#2563EB]" />
              <a href="mailto:sales@radiantmachinetools.com" data-testid="footer-email" className="hover:text-white transition-colors">
                sales@radiantmachinetools.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={15} className="text-[#2563EB]" />
              <span data-testid="footer-location">B-26/4, Ancillary Industrial Estate, BHEL, Ramachandrapuram, Hyderabad, Telangana 502032</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="border-t border-slate-800">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-slate-500">© Radiant Machine Tools. All Rights Reserved.</p>
        <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-slate-600 hover:text-slate-400 transition-colors">
          Admin
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
